<section>
    <div class="preview_text">
        {{showingPreviewText | titlecase}}
    </div>
    <div class="display_website">
        <ng-template #displayWebsite></ng-template>
    </div>
</section>